"use client";

import { useState, useContext, useEffect, useRef, useMemo } from "react";
import {
  TextField,
  Button,
  Typography,
  Box,
  FormControlLabel,
  Checkbox,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Tabs,
  Tab,
  IconButton,
  Chip,
  useTheme,
  alpha,
  Card,
  CardContent,
  CircularProgress,
  Grid,
  InputAdornment,
  AppBar,
  Toolbar,
  Tooltip,
  Alert,
  Snackbar,
  FormControl,
  Select,
  MenuItem,
  InputLabel,
} from "@mui/material";
import Autocomplete from "@mui/material/Autocomplete";
import { ErpContext } from "../../context/ErpContext.js";
import { getLocaleConfig, formatNumberForDisplay, formatInputWithSeparators, handleNumericInputChange } from "../../utils/numeros.js";
import InventoryIcon from "@mui/icons-material/Inventory";
import LocalOfferIcon from "@mui/icons-material/LocalOffer";
import QrCodeScannerIcon from "@mui/icons-material/QrCodeScanner";
import DescriptionIcon from "@mui/icons-material/Description";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import DeleteIcon from "@mui/icons-material/Delete";
import SaveIcon from "@mui/icons-material/Save";
import CategoryIcon from "@mui/icons-material/Category";
import WarehouseIcon from "@mui/icons-material/Warehouse";
import CloseIcon from "@mui/icons-material/Close";
import ReceiptIcon from "@mui/icons-material/Receipt";
import FormatListNumberedIcon from "@mui/icons-material/FormatListNumbered";
import LocalShippingIcon from "@mui/icons-material/LocalShipping";
import React from "react";
import GestionLoteTab from "./GestionLoteTab";
import ModalEditarPrecioId from "./ModalEditarPrecioId";
import ModalEditarPrecioCliente from "./ModalEditarPrecioCliente";
import StarIcon from "@mui/icons-material/Star";
import StarBorderIcon from "@mui/icons-material/StarBorder";
import EditIcon from "@mui/icons-material/Edit";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import PaymentsOutlinedIcon from "@mui/icons-material/PaymentsOutlined";
import PeopleIcon from "@mui/icons-material/People";

// Tab Panel Component
function TabPanel(props) {
  const { children, value, index, ...other } = props;

  // Referencia para el contenedor del panel
  const panelRef = React.useRef(null);

  // Efecto para hacer scroll al inicio cuando cambia la pestaña activa
  React.useEffect(() => {
    if (value === index && panelRef.current) {
      panelRef.current.scrollTop = 0;
    }
  }, [value, index]);

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`item-tabpanel-${index}`}
      aria-labelledby={`item-tab-${index}`}
      ref={panelRef}
      {...other}
      style={{ padding: "20px 0", height: "100%", overflowY: "auto" }}
    >
      {value === index && <Box>{children}</Box>}
    </div>
  );
}

const CreateItemComponentModal = ({ onClose, selectedItem = null }) => {
  const theme = useTheme();
  const {
    postItem,
    getUbicacion,
    ubicaciones,
    getItemUbicacionFilter,
    itemUbicacionFilter,
    updateItem,
    updateItemUbicaciones,
    itemAtributoNoEliminados,
    getItemAtributoNoEliminados,
    getListaMontosByIdItem,
    getEntidadByTipoEntidad,
    updateListaDeMonto,
    updateListaDeMontoBatch,
    postListaMonto,
    isNavbarCollapsed,
    updateItemUbicacion,
    getBomByIdItem,
    getImpuestoItem,
    updateImpuestoItem,
    getImpuestosDisponibles,
    getIvaAFIP,
    getParametrosGlobales,
    updateItemPrecioListaId,
    updateMargenGananciaFiltrado,
    getClientesConPreciosByFiltros,
    promoverProveedorReferente,
    actualizarPreciosClientesDesdeReferente,
    formatoNumericoGlobal,
  } = useContext(ErpContext);

  const localeConfig = useMemo(() => getLocaleConfig(formatoNumericoGlobal || null), [formatoNumericoGlobal]);

  // Tab state
  const [activeTab, setActiveTab] = useState(0);

  // Ref para gestión de lotes
  const gestionLoteTabRef = useRef();

  // Ref para resetear scroll al cambiar de pestaña
  const contentScrollRef = useRef(null);
  useEffect(() => {
    contentScrollRef.current?.scrollTo?.(0, 0);
  }, [activeTab]);

  // Loading states
  const [isLoading, setIsLoading] = useState(false);
  const [isSaving, setIsSaving] = useState(false);
  const [savingItemInfo, setSavingItemInfo] = useState(false);
  const [savingClientes, setSavingClientes] = useState(false);
  const [savingProveedores, setSavingProveedores] = useState(false);

  // Estados para el modal de edición de costo/margen de proveedor
  const [openModalProveedor, setOpenModalProveedor] = useState(false);
  const [precioListaSeleccionado, setPrecioListaSeleccionado] = useState(null);

  // Estados para el modal de edición de precio de cliente
  const [openModalPrecioCliente, setOpenModalPrecioCliente] = useState(false);
  const [precioClienteSeleccionado, setPrecioClienteSeleccionado] = useState(null);

  // Estados para datos del item
  const [descripcionItem, setDescripcionItem] = useState("");
  const [codigoItem, setCodigoItem] = useState("");
  const [selectedUbicaciones, setSelectedUbicaciones] = useState([]);
  const [ubicacionesData, setUbicacionesData] = useState([]);
  const [itemUbicacionData, setItemUbicacionData] = useState({});
  const [ubicacionData, setUbicacionData] = useState([]);
  const [attributeValues, setAttributeValues] = useState({});
  const [activeAttributes, setActiveAttributes] = useState([]);
  const [codigoScannerItem, setCodigoScannerItem] = useState("");
  const [pluBalanzaItem, setPluBalanzaItem] = useState("");
  const [usaGestionLotes, setUsaGestionLotes] = useState(false);

  // Estados para impuestos del item
  const [impuestosDisponibles, setImpuestosDisponibles] = useState([]);
  const [impuestoSeleccionado, setImpuestoSeleccionado] = useState(null);
  const [porcentajeImpuesto, setPorcentajeImpuesto] = useState(21);
  const [impuestoData, setImpuestoData] = useState({
    idItem: null,
    idImpuesto: null,
    porcentaje: 21,
    descripcionImpuesto: "IVA General"
  });

  // Estado para marcar item como eliminado
  const [itemEliminado, setItemEliminado] = useState(false);

  // Estados para registros existentes (lista de precios ya creados)
  const [listaPrecios, setListaPrecios] = useState([]);
  const [editableListaPrecios, setEditableListaPrecios] = useState([]);

  // Estados para nuevos registros a crear
  const [newClientEntry, setNewClientEntry] = useState({
    entidad: null,
    idUbicacion: null,
    monto: "",
  });
  const [newProviderEntry, setNewProviderEntry] = useState({
    entidad: null,
    idUbicacion: null,
    monto: "",
    margenGanancia: "",
    esProveedorReferente: false,
  });
  const [newClientEntries, setNewClientEntries] = useState([]);
  const [newProviderEntries, setNewProviderEntries] = useState([]);

  // Estado para guardar valores originales (para detectar cambios)
  const [originalListaPrecios, setOriginalListaPrecios] = useState([]);

  // Opciones para entidades (para Autocomplete)
  const [entidadesClientes, setEntidadesClientes] = useState([]);
  const [entidadesProveedores, setEntidadesProveedores] = useState([]);

  // Estado para notificaciones
  const [notification, setNotification] = useState({
    open: false,
    message: "",
    severity: "success",
  });

  const [parametrosGlobales, setParametrosGlobales] = useState({});
  const showPluField = parametrosGlobales.pluBalanza === "1";

  // Cargar ubicacionesData a partir de ubicaciones
  useEffect(() => {
    setUbicacionesData(
      ubicaciones.map((ub) => ({
        idUbicacion: ub.id,
        inventario: "",
        precio: "",
        stockMin: "",
      }))
    );
  }, [ubicaciones]);

  // Obtener opciones de entidades
  useEffect(() => {
    const fetchEntidades = async () => {
      setIsLoading(true);
      try {
        const clientes = await getEntidadByTipoEntidad(1);
        setEntidadesClientes(clientes || []);
        const proveedores = await getEntidadByTipoEntidad(2);
        setEntidadesProveedores(proveedores || []);
        const parametros = await getParametrosGlobales(["pluBalanza", "gestionDeLotes"]);
        if (parametros) {
          setParametrosGlobales(parametros);
        }
      } catch (error) {
        console.error("Error al cargar entidades:", error);
        showNotification("Error al cargar entidades", "error");
      } finally {
        setIsLoading(false);
      }
    };
    fetchEntidades();
  }, []);

  // Cuando cambia el item seleccionado
  useEffect(() => {
    if (selectedItem) {
      setIsLoading(true);
      setDescripcionItem(selectedItem.descripcion);
      setCodigoItem(selectedItem.codigo);
      getItemUbicacionFilter(selectedItem.idItem);
      setCodigoScannerItem(selectedItem.codigoScanner);
      setPluBalanzaItem(selectedItem.pluBalanza || "");
      setUsaGestionLotes(selectedItem.usaGestionLotes || false);
      setItemEliminado(selectedItem.eliminado || false);
      fetchData();
      const updatedAttributes = itemAtributoNoEliminados
        .filter((attr) => !attr.eliminado)
        .map((attr, index) => ({
          id: attr.id,
          descripcion: attr.descripcion,
          value:
            selectedItem.activeAttributes[`itemDatoAtributo${index + 1}`] || "",
        }));
      setAttributeValues(updatedAttributes);
      setActiveAttributes(selectedItem.activeAttributes);
      setIsLoading(false);
    }
  }, [selectedItem]);

  useEffect(() => {
    if (itemUbicacionFilter.length > 0) {
      const updatedData = itemUbicacionFilter.reduce((acc, item) => {
        // Formatear inventario a 3 decimales para mostrar
        const inventarioValue = item.inventario || "";
        const inventarioFormateado = inventarioValue !== "" && !isNaN(parseFloat(inventarioValue))
          ? parseFloat(inventarioValue).toFixed(3)
          : inventarioValue;
        
        acc[item.idUbicacion] = {
          inventario: inventarioFormateado,
          stockMin: item.stockMinimo || "",
          inventarioOriginal: item.inventario || 0,
        };
        return acc;
      }, {});
      setUbicacionData(updatedData);
      setSelectedUbicaciones(
        itemUbicacionFilter.map((item) => item.idUbicacion)
      );
    }
  }, [itemUbicacionFilter]);

  // Cargar impuestos disponibles
  useEffect(() => {
    const cargarImpuestos = async () => {
      try {
        const impuestos = await getImpuestosDisponibles();
        setImpuestosDisponibles(impuestos || []);
      } catch (error) {
        console.error("Error al cargar impuestos disponibles:", error);
      }
    };
    cargarImpuestos();
  }, []);

  // Cargar impuesto del item cuando se selecciona
  useEffect(() => {
    const cargarImpuestoItem = async () => {
      if (selectedItem && selectedItem.idItem) {
        try {
          const impuesto = await getImpuestoItem(selectedItem.idItem);
          setImpuestoData(impuesto);
          setPorcentajeImpuesto(impuesto.porcentaje);
          
          // Buscar el impuesto en impuestosDisponibles (BD)
          const impuestoEnBD = impuestosDisponibles.find(imp => imp.id === impuesto.idImpuesto);
          setImpuestoSeleccionado(impuestoEnBD || null);
          
          // Si el impuesto no está en AFIP, mostrar advertencia
          if (!esImpuestoValidoAFIP(impuesto.porcentaje)) {
            console.warn(`El impuesto ${impuesto.porcentaje}% no es válido de AFIP`);
          }
        } catch (error) {
          console.error("Error al cargar impuesto del item:", error);
          // Si no hay impuesto configurado, usar IVA 21% por defecto
          const impuestoDefault = getIvaAFIP().find(imp => imp.porcentaje === 21);
          setImpuestoSeleccionado(impuestoDefault || null);
          setPorcentajeImpuesto(21);
        }
      }
    };
    
    // Cargar impuesto cuando se selecciona un item
    cargarImpuestoItem();
  }, [selectedItem, impuestosDisponibles]);

  useEffect(() => {
    if (Array.isArray(ubicacionData)) {
      const initialData = ubicacionData.reduce((acc, item) => {
        acc[item.idUbicacion] = {
          idUbicacionNumero: item.idUbicacion,
          inventario: item.inventario,
          precio: item.precio,
          stockMin: item.stockMinimo,
        };
        return acc;
      }, {});
      setItemUbicacionData(initialData);
    } else {
      const initialData = Object.keys(ubicacionData).map((key) => ({
        idUbicacion: key,
        ...ubicacionData[key],
      }));
      setItemUbicacionData(initialData);
    }
  }, [ubicacionData]);

  // Obtener registros existentes de ListaDeMontos (carga completa: ubicaciones, atributos, montos)
  const fetchData = async () => {
    setIsLoading(true);
    try {
      await getUbicacion();
      await getItemAtributoNoEliminados();
      const items = await getListaMontosByIdItem(selectedItem.idItem);

      console.log(items);

      if (items != null) {
        // Aplanar y ordenar
        const itemsTransformados = items.map((item) => ({
          id: `${item.idItem}-${item.idEntidad}-${item.ubicacion.id}-${item.fecha}`, // Generar un ID único
          fecha: item.fechaComun,
          idItem: item.idItem,
          idEntidad: item.idEntidad,
          idTipoEntidad: item.entidad.idTipoEntidad,
          idUbicacion: item.ubicacion.id,
          monto: item.monto,
          margenGanancia: item.margenGanancia ?? null,
          esProveedorReferente: item.esProveedorReferente ?? false,
          descripcionEntidad:
            `${item.entidad?.descripcion} ${item.entidad?.apellido}` ||
            "Sin descripción", // Extraer descripción de 'item'
          ubicacion: item.ubicacion?.descripcion || "Sin ubicación", // Extraer descripción de 'ubicacion'
          descripcion: item.item?.descripcion || "Sin descripción", // Extraer descripción de 'item'
          codigo: item.item?.codigo || "Sin código", // Extraer código de 'item'
          codigoScanner: item.item?.codigoScanner || "Sin código", // Extraer código de 'item'
          leadTime: item.leadTime,
          eliminado: item.eliminado,
          createdAt: new Date(item.createdAt).toLocaleDateString("es-AR"),
          updatedAt: new Date(item.updatedAt).toLocaleDateString("es-AR"),
        }));

        // Ordenar por idItem
        itemsTransformados.sort((a, b) => a.idItem - b.idItem);

        setListaPrecios(itemsTransformados || []);
        setEditableListaPrecios(itemsTransformados || []);
        // Guardar una copia profunda de los valores originales para detectar cambios
        setOriginalListaPrecios(JSON.parse(JSON.stringify(itemsTransformados || [])));
      }
    } finally {
      setIsLoading(false);
    }
  };

  // Refresh ligero: solo lista de montos (sin actualizar contexto global)
  const refreshListaMontos = async () => {
    if (!selectedItem?.idItem) return;
    setIsLoading(true);
    try {
      const items = await getListaMontosByIdItem(selectedItem.idItem);
      if (items != null) {
        const itemsTransformados = items.map((item) => ({
          id: `${item.idItem}-${item.idEntidad}-${item.ubicacion.id}-${item.fecha}`,
          fecha: item.fechaComun,
          idItem: item.idItem,
          idEntidad: item.idEntidad,
          idTipoEntidad: item.entidad.idTipoEntidad,
          idUbicacion: item.ubicacion.id,
          monto: item.monto,
          margenGanancia: item.margenGanancia ?? null,
          esProveedorReferente: item.esProveedorReferente ?? false,
          descripcionEntidad:
            `${item.entidad?.descripcion} ${item.entidad?.apellido}` || "Sin descripción",
          ubicacion: item.ubicacion?.descripcion || "Sin ubicación",
          descripcion: item.item?.descripcion || "Sin descripción",
          codigo: item.item?.codigo || "Sin código",
          codigoScanner: item.item?.codigoScanner || "Sin código",
          leadTime: item.leadTime,
          eliminado: item.eliminado,
          createdAt: new Date(item.createdAt).toLocaleDateString("es-AR"),
          updatedAt: new Date(item.updatedAt).toLocaleDateString("es-AR"),
        }));
        itemsTransformados.sort((a, b) => a.idItem - b.idItem);
        setListaPrecios(itemsTransformados || []);
        setEditableListaPrecios(itemsTransformados || []);
        setOriginalListaPrecios(JSON.parse(JSON.stringify(itemsTransformados || [])));
      }
    } finally {
      setIsLoading(false);
    }
  };

  const handleAttributeChange = (index, value) => {
    setAttributeValues((prev) => ({
      ...prev,
      [index]: { ...prev[index], value },
    }));
  };

  // Función para mostrar notificaciones
  const showNotification = (message, severity = "success") => {
    setNotification({
      open: true,
      message,
      severity,
    });
  };

  // Cerrar notificación
  const handleCloseNotification = () => {
    setNotification({
      ...notification,
      open: false,
    });
  };

  // Actualizar el monto en un registro existente (solo se modifica el monto)
  // Corregido para actualizar solo la fila específica
  const updateEditableRow = (rowId, tipoEntidad, value) => {
    setEditableListaPrecios((prev) =>
      prev.map((row) => {
        if (row.id === rowId) {
          return { ...row, monto: value };
        }
        return row;
      })
    );
  };

  const handleItemSubmit = async (e) => {
    e.preventDefault();

    // Validar que el código tenga al menos 3 caracteres
    if (!codigoItem || codigoItem.trim().length < 3) {
      showNotification("El código debe tener al menos 3 caracteres", "error");
      return;
    }

    setSavingItemInfo(true);
    try {
      const atributos = Object.keys(attributeValues).map((index) => ({
        valor: attributeValues[index].value,
      }));
      await updateItem(
        selectedItem.idItem,
        descripcionItem,
        codigoItem,
        codigoScannerItem,
        atributos,
        itemEliminado,
        showPluField ? pluBalanzaItem : undefined,
        usaGestionLotes
      );
      const ubicacionesPayload = selectedUbicaciones.map((ubId) => ({
        idUbicacion: ubId,
        inventario: ubicacionData[ubId].inventario,
        stockMinimo: ubicacionData[ubId].stockMin,
        inventarioOriginal: ubicacionData[ubId].inventarioOriginal,
      }));
      await updateItemUbicaciones(selectedItem.idItem, ubicacionesPayload);

      // Manejo separado de BOM
      const receta = await getBomByIdItem(selectedItem.idItem);
      if (receta && receta.length > 0 && (ubicacionesPayload[0].inventario > ubicacionesPayload[0].inventarioOriginal)) {
        for (const ingrediente of receta) {
          await updateItemUbicacion(
            ingrediente.idMateriaPrima,
            1, //Hardcoded porque por ahora asociamos el item directamente, no su ubicacion
             ingrediente.cantidad * (ubicacionesPayload[0].inventario - ubicacionesPayload[0].inventarioOriginal), //Por el momento tomamos la primera ubicacion, luego se puede mejorar
            "venta" //No es una venta pero es el controller que reutilizamos de componenteVentas, lo que hace esto es dar la orden de que descuente la cantidad que se manda.
          );
        }
      }

      showNotification("Información del ítem actualizada con éxito");
    } catch (error) {
      console.error("Error al actualizar el item:", error);
      showNotification("Error al actualizar el ítem", "error");
    } finally {
      setSavingItemInfo(false);
    }
  };

  const handleUbicacionChange = (id) => {
    setSelectedUbicaciones((prev) =>
      prev.includes(id) ? prev.filter((x) => x !== id) : [...prev, id]
    );
  };

  const handleSelectAllChange = () => {
    if (selectedUbicaciones.length === ubicaciones.length) {
      setSelectedUbicaciones([]);
    } else {
      setSelectedUbicaciones(ubicaciones.map((ub) => ub.id));
    }
  };

  const handleInventarioPrecioChange = (ubId, field, value) => {
    setUbicacionData((prev) => ({
      ...prev,
      [ubId]: { ...prev[ubId], [field]: value },
    }));
  };

  // Funciones para manejar impuestos
  // handleImpuestoChange: Se ejecuta cuando se selecciona en el Autocomplete (izquierda)
  // Actualiza tanto impuestoSeleccionado como porcentajeImpuesto
  const handleImpuestoChange = (event, newValue) => {
    setImpuestoSeleccionado(newValue);
    if (newValue) {
      setPorcentajeImpuesto(newValue.porcentaje);
    }
  };

  // Función para validar si un impuesto es válido de AFIP
  const esImpuestoValidoAFIP = (porcentaje) => {
    const impuestosAFIP = getIvaAFIP();
    return impuestosAFIP.some(imp => Math.abs(imp.porcentaje - porcentaje) < 0.01);
  };

  // Función para obtener impuestos válidos para un item específico
  const getImpuestosValidosParaItem = (itemId, impuestoActual = null) => {
    const impuestosAFIP = getIvaAFIP();
    
    // Si hay un impuesto actual configurado para este item
    if (impuestoActual && impuestoActual.porcentaje !== undefined) {
      // Buscar si existe un impuesto de AFIP con el mismo porcentaje
      const impuestoAFIPCoincidente = impuestosAFIP.find(imp => 
        Math.abs(imp.porcentaje - impuestoActual.porcentaje) < 0.01
      );
      
      // Si encontramos un impuesto de AFIP con el mismo porcentaje, usar ese
      if (impuestoAFIPCoincidente) {
        return impuestosAFIP;
      }
      
      // Si no hay coincidencia, agregar el impuesto personalizado
      return [
        {
          id: impuestoActual.idImpuesto || `custom_${impuestoActual.porcentaje}`,
          descripcion: impuestoActual.descripcionImpuesto || `Impuesto ${impuestoActual.porcentaje}%`,
          porcentaje: impuestoActual.porcentaje,
          codigoAFIP: "CUSTOM"
        },
        ...impuestosAFIP
      ];
    }
    
    // Retornar solo los impuestos válidos de AFIP
    return impuestosAFIP;
  };

  const handlePorcentajeChange = (event) => {
    setPorcentajeImpuesto(parseFloat(event.target.value) || 0);
  };

  const handleSaveImpuesto = async () => {
    if (!selectedItem || !selectedItem.idItem) {
      showNotification("No hay un ítem seleccionado", "error");
      return;
    }

    // Validar que el porcentaje seleccionado sea válido de AFIP
    if (!esImpuestoValidoAFIP(porcentajeImpuesto)) {
      showNotification("Debe seleccionar un impuesto válido de AFIP", "error");
      return;
    }

    try {
      console.log("Guardando impuesto:", {
        itemId: selectedItem.idItem,
        porcentajeImpuesto: porcentajeImpuesto,
        impuestoDataOriginal: impuestoData
      });

      // Buscar el impuesto AFIP correspondiente al porcentaje
      const impuestosAFIP = getIvaAFIP();
      const impuestoAFIPSeleccionado = impuestosAFIP.find(imp => 
        Math.abs(imp.porcentaje - porcentajeImpuesto) < 0.01
      );

      // Determinar qué ID de impuesto usar para la actualización
      let idImpuestoParaActualizar = impuestoAFIPSeleccionado?.id;
      
      // Si el item tenía un impuesto personalizado, usar ese ID
      if (impuestoData && impuestoData.idImpuesto) {
        // Verificar si el impuesto original no es de AFIP
        const esImpuestoOriginalAFIP = impuestosAFIP.find(imp => imp.id === impuestoData.idImpuesto);
        
        if (!esImpuestoOriginalAFIP) {
          // Usar el ID original del impuesto del item
          idImpuestoParaActualizar = impuestoData.idImpuesto;
        }
      }

      await updateImpuestoItem(
        selectedItem.idItem,
        idImpuestoParaActualizar,
        porcentajeImpuesto
      );
      showNotification("Impuesto del ítem actualizado con éxito");
      
      // Actualizar los datos locales
      setImpuestoData({
        idItem: selectedItem.idItem,
        idImpuesto: idImpuestoParaActualizar,
        porcentaje: porcentajeImpuesto,
        descripcionImpuesto: impuestoAFIPSeleccionado?.descripcion || `IVA ${porcentajeImpuesto}%`
      });
    } catch (error) {
      console.error("Error al actualizar impuesto del item:", error);
      showNotification("Error al actualizar impuesto del ítem", "error");
    }
  };

  const allSelected = selectedUbicaciones.length === ubicaciones.length;
  const someSelected = selectedUbicaciones.length > 0 && !allSelected;

  // --- Actualizar registros existentes ---
  const handleUpdateExisting = async (tipoEntidad) => {
    if (!selectedItem || !selectedItem.idItem) {
      console.error("No hay un item seleccionado");
      showNotification("No hay un ítem seleccionado", "error");
      return;
    }

    if (tipoEntidad === 1) {
      setSavingClientes(true);
    } else {
      setSavingProveedores(true);
    }

    try {
      const filteredRows = editableListaPrecios.filter(
        (row) => row.idTipoEntidad === tipoEntidad
      );

      console.log("filteredRows " + filteredRows);
      for (const row of filteredRows) {
        console.log("row " + row);
        if (row.idUbicacion && row.idEntidad && row.monto !== undefined) {
          await updateListaDeMonto({
            idItem: selectedItem.idItem,
            idUbicacion: row.idUbicacion,
            idEntidad: row.idEntidad,
            monto: row.monto,
          });
        } else {
          console.warn("Fila incompleta, no se actualizará:", row);
        }
      }

      showNotification(
        tipoEntidad === 1
          ? "Precios de clientes actualizados correctamente"
          : "Costos de proveedores actualizados correctamente"
      );
      await refreshListaMontos();
    } catch (error) {
      console.error("Error al actualizar registros existentes:", error);
      showNotification("Error al actualizar registros", "error");
    } finally {
      if (tipoEntidad === 1) {
        setSavingClientes(false);
      } else {
        setSavingProveedores(false);
      }
    }
  };

  // --- Agregar nuevos registros (Clientes) ---
  const handleNewClientChange = (field, value) => {
    setNewClientEntry((prev) => ({ ...prev, [field]: value }));
  };

  const handleAddNewClient = () => {
    if (!newClientEntry.entidad || !newClientEntry.idUbicacion) {
      showNotification(
        "Debe seleccionar cliente y ubicación",
        "warning"
      );
      return;
    }
    const newEntry = {
      ...newClientEntry,
      monto: newClientEntry.monto === "" ? 0 : newClientEntry.monto,
      fecha: new Date().toISOString(),
      idItem: selectedItem.idItem,
    };
    setNewClientEntries((prev) => [...prev, newEntry]);
    setNewClientEntry({ entidad: null, idUbicacion: null, monto: "" });
  };

  // --- Agregar nuevos registros (Proveedores) ---
  const handleNewProviderChange = (field, value) => {
    setNewProviderEntry((prev) => ({ ...prev, [field]: value }));
  };

  const handleAddNewProvider = () => {
    if (
      !newProviderEntry.entidad ||
      !newProviderEntry.idUbicacion ||
      newProviderEntry.monto === ""
    ) {
      showNotification(
        "Debe completar todos los campos para agregar un proveedor",
        "warning"
      );
      return;
    }
    const newEntry = {
      ...newProviderEntry,
      fecha: new Date().toISOString(),
      idItem: selectedItem.idItem,
    };
    setNewProviderEntries((prev) => [...prev, newEntry]);
    setNewProviderEntry({ entidad: null, idUbicacion: null, monto: "", margenGanancia: "", esProveedorReferente: false });
  };

  // Filtrar opciones para nuevos registros
  const availableClientEntities = entidadesClientes.filter((ent) => {
    const usedInExisting = editableListaPrecios.some(
      (row) =>
        row.entidad &&
        row.entidad.id === ent.id &&
        row.entidad.idTipoEntidad === 1
    );
    const usedInNew = newClientEntries.some(
      (entry) => entry.entidad === ent.id
    );
    return !usedInExisting && !usedInNew;
  });

  const availableProviderEntities = entidadesProveedores.filter((ent) => {
    const usedInExisting = editableListaPrecios.some(
      (row) =>
        row.entidad &&
        row.entidad.id === ent.id &&
        row.entidad.idTipoEntidad === 2
    );
    const usedInNew = newProviderEntries.some(
      (entry) => entry.entidad === ent.id
    );
    return !usedInExisting && !usedInNew;
  });

  const availableUbicaciones = ubicaciones.filter((ub) =>
    selectedUbicaciones.includes(ub.id)
  );

  // Enviar nuevos registros al backend
  const handleSaveNewEntries = async (tipoEntidad) => {
    if (!selectedItem || !selectedItem.idItem) {
      console.error("No hay un item seleccionado");
      showNotification("No hay un ítem seleccionado", "error");
      return;
    }

    const entries = tipoEntidad === 1 ? newClientEntries : newProviderEntries;

    if (entries.length === 0) {
      showNotification("No hay nuevas relaciones para guardar", "info");
      return;
    }

    if (tipoEntidad === 1) {
      setSavingClientes(true);
    } else {
      setSavingProveedores(true);
    }

    try {
      for (const entry of entries) {
        const margen =
          tipoEntidad === 2 && entry.margenGanancia !== "" && entry.margenGanancia !== null
            ? Number.parseFloat(entry.margenGanancia)
            : null;
        const esReferente = tipoEntidad === 2 ? (entry.esProveedorReferente ?? false) : false;
        await postListaMonto(
          selectedItem.idItem,
          Number.parseInt(entry.idUbicacion, 10),
          Number.parseInt(entry.entidad, 10),
          tipoEntidad === 1 ? (Number.parseFloat(entry.monto) || 0) : Number.parseFloat(entry.monto),
          margen,
          esReferente
        );
      }

      showNotification(
        tipoEntidad === 1
          ? "Nuevos precios de clientes agregados correctamente"
          : "Nuevos costos de proveedores agregados correctamente"
      );

      if (tipoEntidad === 1) {
        setNewClientEntries([]);
      } else {
        setNewProviderEntries([]);
      }

      refreshListaMontos();
    } catch (error) {
      console.error("Error al crear nuevas relaciones:", error);
      showNotification("Error al agregar nuevas relaciones", "error");
    } finally {
      if (tipoEntidad === 1) {
        setSavingClientes(false);
      } else {
        setSavingProveedores(false);
      }
    }
  };

  // Eliminar una entrada de la lista de nuevos registros
  const handleDeleteNewEntry = (index, tipoEntidad) => {
    if (tipoEntidad === 1) {
      setNewClientEntries((prev) => prev.filter((_, i) => i !== index));
    } else {
      setNewProviderEntries((prev) => prev.filter((_, i) => i !== index));
    }
  };

  // Abrir modal de edición de costo/margen para un proveedor existente
  const handleOpenModalProveedor = (row) => {
    setPrecioListaSeleccionado({
      idItem: row.idItem,
      idEntidad: row.idEntidad,
      idUbicacion: row.idUbicacion,
      costo: row.monto,
      margenGanancia: row.margenGanancia,
      esProveedorReferente: row.esProveedorReferente,
    });
    setOpenModalProveedor(true);
  };

  const handleCloseModalProveedor = () => {
    setOpenModalProveedor(false);
    setPrecioListaSeleccionado(null);
  };

  const handleOpenModalPrecioCliente = (row) => {
    setPrecioClienteSeleccionado({
      id: row.id,
      idItem: row.idItem,
      idEntidad: row.idEntidad,
      idUbicacion: row.idUbicacion,
      monto: row.monto,
      descripcionEntidad: row.descripcionEntidad,
      ubicacion: row.ubicacion,
    });
    setOpenModalPrecioCliente(true);
  };

  const handleCloseModalPrecioCliente = () => {
    setOpenModalPrecioCliente(false);
    setPrecioClienteSeleccionado(null);
  };

  const [saveProgress, setSaveProgress] = useState({
    item: false,
    impuesto: false,
    clientes: false,
    proveedores: false,
    nuevosClientes: false,
    nuevosProveedores: false,
  });

  const [saveError, setSaveError] = useState(null);

  const handleSaveAll = async () => {
    // Validar que el código tenga al menos 3 caracteres
    if (!codigoItem || codigoItem.trim().length < 3) {
      showNotification("El código debe tener al menos 3 caracteres", "error");
      return;
    }

    // Resetear estados
    setSaveProgress({
      item: false,
      impuesto: false,
      clientes: false,
      proveedores: false,
      nuevosClientes: false,
      nuevosProveedores: false,
    });
    setSaveError(null);
    setIsSaving(true);

    // Variables para tracking de resultados
    let resultadoLotes = null;
    let itemGuardado = false;

    try {
      // 0️⃣ Guardar cambios pendientes de lotes (FLUJO INDEPENDIENTE, NO BLOQUEANTE)
      if (usaGestionLotes && gestionLoteTabRef.current) {
        console.log("💾 Guardando cambios pendientes de lotes...");
        try {
          resultadoLotes = await gestionLoteTabRef.current.guardarCambiosPendientesLotes();
          
          if (resultadoLotes.exitosos > 0) {
            console.log(`✅ ${resultadoLotes.exitosos} cambios de lotes guardados`);
          }
          
          if (resultadoLotes.fallidos > 0) {
            console.warn(`⚠️  ${resultadoLotes.fallidos} cambios de lotes fallaron:`, resultadoLotes.errores);
          }
        } catch (errorLotes) {
          console.error("❌ Error al guardar cambios de lotes:", errorLotes);
          resultadoLotes = { exitosos: 0, fallidos: 1, errores: [errorLotes.message] };
        }
      }

      // 1. Guardar información básica del ítem
      const atributos = Object.keys(attributeValues).map((index) => ({
        valor: attributeValues[index].value,
      }));

      console.log("🔄 Enviando datos al backend:", {
        itemId: selectedItem.idItem,
        descripcionItem,
        codigoItem,
        codigoScannerItem,
        eliminado: itemEliminado,
        usaGestionLotes
      });

      await updateItem(
        selectedItem.idItem,
        descripcionItem,
        codigoItem,
        codigoScannerItem,
        atributos,
        itemEliminado,
        showPluField ? pluBalanzaItem : undefined,
        usaGestionLotes
      );
      setSaveProgress((prev) => ({ ...prev, item: true }));
      itemGuardado = true; // Marcar que el item se guardó correctamente

      // 2. Guardar impuesto del item
      if (impuestoSeleccionado && (impuestoData.idImpuesto !== impuestoSeleccionado.id || impuestoData.porcentaje !== porcentajeImpuesto)) {
        await updateImpuestoItem(
          selectedItem.idItem,
          impuestoSeleccionado.id,
          porcentajeImpuesto
        );
      }
      setSaveProgress((prev) => ({ ...prev, impuesto: true }));

      // 3. Guardar ubicaciones y obtener receta en paralelo (PARALELIZACIÓN)
      const ubicacionesPayload = selectedUbicaciones.map((ubId) => ({
        idUbicacion: ubId,
        inventario: ubicacionData[ubId]?.inventario || 0,
        stockMinimo: ubicacionData[ubId]?.stockMin || 0,
        inventarioOriginal: ubicacionData[ubId]?.inventarioOriginal || 0,
      }));

      // Ejecutar en paralelo: actualizar ubicaciones y obtener receta
      const [, receta] = await Promise.all([
        updateItemUbicaciones(selectedItem.idItem, ubicacionesPayload),
        getBomByIdItem(selectedItem.idItem)
      ]);

      // Manejo de BOM si hay receta y hay aumento de inventario
      if (receta && receta.length > 0 && ubicacionesPayload.length > 0 && 
          (ubicacionesPayload[0].inventario > ubicacionesPayload[0].inventarioOriginal)) {
        // Actualizar ingredientes en paralelo
        const promesasIngredientes = receta.map(ingrediente =>
          updateItemUbicacion(
            ingrediente.idMateriaPrima,
            1, //Hardcoded porque por ahora asociamos el item directamente, no su ubicacion
            ingrediente.cantidad * (ubicacionesPayload[0].inventario - ubicacionesPayload[0].inventarioOriginal),//Por el momento tomamos la primera ubicacion, luego se puede mejorar
            "venta" //No es una venta pero es el controller que reutilizamos de componenteVentas, lo que hace esto es dar la orden de que descuente la cantidad que se manda.
          )
        );
        await Promise.all(promesasIngredientes);
      }
      // 4. Detectar cambios reales en precios antes de actualizar (VALIDACIÓN PREVIA)
      const preciosModificados = editableListaPrecios.filter(row => {
        const original = originalListaPrecios.find(orig => orig.id === row.id);
        if (!original) return false;
        // Comparar montos con precisión de 2 decimales
        return Math.abs(parseFloat(original.monto) - parseFloat(row.monto)) > 0.01;
      });

      // Preparar actualizaciones en paralelo
      const promesasActualizacion = [];

      // 5. Actualizar precios modificados usando batch (UNA SOLA LLAMADA)
      if (preciosModificados.length > 0) {
        const updates = preciosModificados.map(row => ({
          idItem: selectedItem.idItem,
          idUbicacion: row.idUbicacion,
          idEntidad: row.idEntidad,
          monto: row.monto,
        }));
        
        console.log(`📊 Actualizando ${preciosModificados.length} precios en batch`);
        promesasActualizacion.push(
          updateListaDeMontoBatch(updates)
            .then(() => {
              setSaveProgress((prev) => ({ ...prev, clientes: true, proveedores: true }));
            })
        );
      } else {
        // Si no hay cambios, marcar como completado
        setSaveProgress((prev) => ({ ...prev, clientes: true, proveedores: true }));
      }

      // 6. Guardar nuevos precios de clientes en paralelo
      if (newClientEntries.length > 0) {
        const promesasClientes = newClientEntries.map(entry =>
          postListaMonto(
            selectedItem.idItem,
            Number.parseInt(entry.idUbicacion, 10),
            Number.parseInt(entry.entidad, 10),
            Number.parseFloat(entry.monto) || 0
          )
        );
        promesasActualizacion.push(
          Promise.all(promesasClientes)
            .then(() => {
              setSaveProgress((prev) => ({ ...prev, nuevosClientes: true }));
            })
        );
      } else {
        setSaveProgress((prev) => ({ ...prev, nuevosClientes: true }));
      }

      // 7. Guardar nuevos costos de proveedores en paralelo
      if (newProviderEntries.length > 0) {
        const promesasProveedores = newProviderEntries.map(entry => {
          const margen =
            entry.margenGanancia !== "" && entry.margenGanancia !== null
              ? Number.parseFloat(entry.margenGanancia)
              : null;
          return postListaMonto(
            selectedItem.idItem,
            Number.parseInt(entry.idUbicacion, 10),
            Number.parseInt(entry.entidad, 10),
            Number.parseFloat(entry.monto),
            margen,
            entry.esProveedorReferente ?? false
          );
        });
        promesasActualizacion.push(
          Promise.all(promesasProveedores)
            .then(() => {
              setSaveProgress((prev) => ({ ...prev, nuevosProveedores: true }));
            })
        );
      } else {
        setSaveProgress((prev) => ({ ...prev, nuevosProveedores: true }));
      }

      // Ejecutar todas las actualizaciones de precios en paralelo
      await Promise.all(promesasActualizacion);

      // Actualizar valores originales sin recargar desde el servidor (OPTIMIZACIÓN)
      // Los datos ya están actualizados en editableListaPrecios, solo sincronizamos el estado original
      setOriginalListaPrecios(JSON.parse(JSON.stringify(editableListaPrecios)));
      
      // Limpiar entradas nuevas (ya guardadas)
      setNewClientEntries([]);
      setNewProviderEntries([]);

      // Determinar mensaje final según resultados
      const totalCambios = preciosModificados.length + newClientEntries.length + newProviderEntries.length;
      
      if (itemGuardado && resultadoLotes && resultadoLotes.exitosos > 0 && resultadoLotes.fallidos === 0) {
        showNotification(`✅ Todos los cambios guardados correctamente (item + lotes + ${totalCambios} precios)`, "success");
      } else if (itemGuardado && resultadoLotes && resultadoLotes.fallidos > 0) {
        showNotification(
          `✅ Item guardado. ⚠️ Error al guardar ${resultadoLotes.fallidos} stock(s) de lotes: ${resultadoLotes.errores.join(", ")}`,
          "warning"
        );
      } else if (itemGuardado) {
        if (totalCambios > 0) {
          showNotification(`✅ Todos los cambios guardados correctamente (${totalCambios} precios actualizados)`, "success");
        } else {
          showNotification("✅ Todos los cambios guardados correctamente", "success");
        }
      }

      onClose();
    } catch (error) {
      console.error("Error al guardar los cambios:", error);
      
      // Si hubo error en el item pero los lotes se guardaron
      if (resultadoLotes && resultadoLotes.exitosos > 0) {
        setSaveError(error.message || "Error al guardar el item");
        showNotification(
          `⚠️ Stocks de lotes guardados (${resultadoLotes.exitosos}), pero error al guardar item: ${error.message}`,
          "warning"
        );
      } else {
        setSaveError(error.message || "Error al guardar los cambios");
        showNotification("❌ Error al guardar los cambios", "error");
      }
    } finally {
      setIsSaving(false);
    }
  };

  return (
    <Box
      sx={{
        width: "100%",
        height: "100%",
        display: "flex",
        flexDirection: "column",
      }}
    >
      {/* Header sticky compacto: título + ubicaciones + tabs */}
      <AppBar
        position="sticky"
        elevation={2}
        sx={{
          borderTopLeftRadius: "8px",
          borderTopRightRadius: "8px",
          backgroundColor: theme.palette.background.paper,
          borderBottom: `1px solid rgb(244, 147, 14)`,
          color: "black",
        }}
      >
        {/* Fila única: título + ubicaciones inline + cerrar */}
        <Toolbar sx={{ minHeight: 40, py: 0, px: 1.5, justifyContent: "space-between", alignItems: "center" }}>
          <Box sx={{ display: "flex", alignItems: "center", gap: 1.5, flex: 1, minWidth: 0 }}>
            <InventoryIcon sx={{ color: "rgb(244, 147, 14)", fontSize: 20, flexShrink: 0 }} />
            <Typography variant="subtitle1" component="div" sx={{ fontWeight: 600, fontSize: "0.95rem", flexShrink: 0 }}>
              {selectedItem ? `Editar Item: ${selectedItem.descripcion}` : "Crear Nuevo Item"}
            </Typography>
            {selectedUbicaciones.length > 0 && (
              <Box sx={{ display: "flex", alignItems: "center", gap: 0.5, flexWrap: "wrap", overflow: "hidden" }}>
                <WarehouseIcon sx={{ fontSize: 14, color: "text.secondary", flexShrink: 0 }} />
                <Typography variant="caption" sx={{ color: "text.secondary", flexShrink: 0, whiteSpace: "nowrap" }}>
                  Ubicaciones:
                </Typography>
                {selectedUbicaciones.map((ubId) => (
                  <Chip
                    key={ubId}
                    label={ubicaciones.find((u) => u.id === ubId)?.descripcion || ubId}
                    size="small"
                    variant="outlined"
                    sx={{ height: 22, fontSize: "0.7rem", "& .MuiChip-label": { px: 0.75, py: 0 } }}
                  />
                ))}
              </Box>
            )}
          </Box>
          <Tooltip title="Cerrar">
            <IconButton size="small" onClick={onClose} sx={{ "&:hover": { backgroundColor: alpha(theme.palette.error.light, 0.2) } }}>
              <CloseIcon sx={{ fontSize: 20 }} />
            </IconButton>
          </Tooltip>
        </Toolbar>

        {/* Tabs compactos */}
        <Tabs
          value={activeTab}
          onChange={(e, newValue) => setActiveTab(newValue)}
          variant="fullWidth"
          sx={{
            backgroundColor: "#5b5b5f",
            minHeight: 0,
            "& .MuiTab-root": {
              textTransform: "none",
              fontWeight: 500,
              fontSize: "0.8rem",
              minHeight: 36,
              color: "rgba(255,255,255,0.7)",
              transition: "background-color 0.15s",
              "&:hover": { backgroundColor: "rgba(255,255,255,0.07)" },
            },
            "& .Mui-selected": {
              color: "white !important",
              fontWeight: 600,
              backgroundColor: "#4a4a4e",
            },
            "& .MuiTabs-indicator": {
              backgroundColor: "rgb(244, 147, 14)",
              height: 3,
            },
          }}
        >
          <Tab
            icon={<InfoOutlinedIcon sx={{ fontSize: 16 }} />}
            iconPosition="start"
            label="Información del Item"
            id="item-tab-0"
            aria-controls="item-tabpanel-0"
          />
          <Tab
            icon={<PaymentsOutlinedIcon sx={{ fontSize: 16 }} />}
            iconPosition="start"
            label="Precios y Costos"
            id="item-tab-1"
            aria-controls="item-tabpanel-1"
          />
          {/* Tab de Gestión de Lotes (solo si está activado y el item usa lotes) */}
          {parametrosGlobales?.gestionDeLotes === "1" && usaGestionLotes && (
            <Tab
              icon={<LocalShippingIcon sx={{ fontSize: 16 }} />}
              iconPosition="start"
              label="Gestión de Lotes"
              id="item-tab-2"
              aria-controls="item-tabpanel-2"
            />
          )}
        </Tabs>
      </AppBar>

      {/* Contenido principal con scroll - padding reducido para maximizar área visible */}
      <Box
        ref={contentScrollRef}
        sx={{
          flex: 1,
          overflow: "auto",
          px: 2,
          py: 1.5,
          backgroundColor: alpha(theme.palette.background.default, 0.5),
        }}
      >
        {isLoading ? (
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              p: 4,
              flex: 1,
            }}
          >
            <CircularProgress size={40} />
          </Box>
        ) : (
          <>
            {/* Contenido de las pestañas */}
            <Box
              sx={{
                flex: 1,
                overflow: "hidden",
                display: "flex",
                flexDirection: "column",
              }}
            >
              <TabPanel value={activeTab} index={0}>
                <form onSubmit={handleItemSubmit}>
                  <Card elevation={1} sx={{ mb: 2, borderRadius: 2, overflow: "hidden", border: "1px solid", borderColor: "divider" }}>
                    <Box sx={{ px: 1.5, py: 1, borderBottom: "1px solid", borderColor: "divider", bgcolor: "grey.50", display: "flex", alignItems: "center", gap: 1 }}>
                      <DescriptionIcon sx={{ fontSize: 18, color: "text.secondary" }} />
                      <Typography variant="subtitle2" fontWeight={700} sx={{ fontSize: "0.9rem" }}>Datos Básicos del Ítem</Typography>
                    </Box>
                    <CardContent sx={{ p: 1.5 }}>
                      <Grid container spacing={1.5}>
                        <Grid item xs={12} md={6}>
                          <TextField
                            label="Descripción Item"
                            variant="outlined"
                            size="small"
                            fullWidth
                            value={descripcionItem}
                            onChange={(e) => setDescripcionItem(e.target.value)}
                          />
                        </Grid>
                        <Grid item xs={12} md={3}>
                          <TextField
                            label="Código"
                            variant="outlined"
                            size="small"
                            fullWidth
                            value={codigoItem}
                            onChange={(e) => setCodigoItem(e.target.value)}
                            error={codigoItem.trim().length > 0 && codigoItem.trim().length < 3}
                            helperText={codigoItem.trim().length > 0 && codigoItem.trim().length < 3 ? "Mín. 3 caracteres" : ""}
                          />
                        </Grid>
                        <Grid item xs={12} md={3}>
                          <TextField
                            label="Código Scanner"
                            variant="outlined"
                            size="small"
                            fullWidth
                            value={codigoScannerItem}
                            onChange={(e) => setCodigoScannerItem(e.target.value)}
                          />
                        </Grid>
                        {showPluField && (
                          <Grid item xs={12} md={3}>
                            <TextField
                              label="PLU Balanza"
                              variant="outlined"
                              size="small"
                              fullWidth
                              value={pluBalanzaItem}
                              onChange={(e) => setPluBalanzaItem(e.target.value)}
                            />
                          </Grid>
                        )}
                      </Grid>
                    </CardContent>
                  </Card>

                  <Card elevation={1} sx={{ mb: 2, borderRadius: 2, overflow: "hidden", border: "1px solid", borderColor: "divider" }}>
                    <Box sx={{ px: 1.5, py: 1, borderBottom: "1px solid", borderColor: "divider", bgcolor: "grey.50", display: "flex", alignItems: "center", gap: 1 }}>
                      <CategoryIcon sx={{ fontSize: 18, color: "text.secondary" }} />
                      <Typography variant="subtitle2" fontWeight={700} sx={{ fontSize: "0.9rem" }}>Atributos del Ítem</Typography>
                    </Box>
                    <CardContent sx={{ p: 1.5 }}>
                      <Grid container spacing={1.5}>
                        {itemAtributoNoEliminados
                          .filter((attr) => !attr.eliminado)
                          .map((attr, index) => (
                            <Grid item xs={12} sm={6} md={3} key={attr.id}>
                              <TextField
                                label={attr.descripcion || "No existe atributo"}
                                variant="outlined"
                                size="small"
                                value={attributeValues[index]?.value || ""}
                                onChange={(e) => handleAttributeChange(index, e.target.value)}
                                fullWidth
                              />
                            </Grid>
                          ))}
                      </Grid>

                      {/* Checkbox Gestión de Lotes */}
                      {parametrosGlobales?.gestionDeLotes === "1" && (
                        <Box sx={{ mt: 2 }}>
                          <FormControlLabel
                            control={
                              <Checkbox
                                checked={usaGestionLotes}
                                onChange={(e) => setUsaGestionLotes(e.target.checked)}
                                sx={{
                                  color: 'rgb(244, 147, 14)',
                                  '&.Mui-checked': {
                                    color: 'rgb(244, 147, 14)',
                                  },
                                }}
                              />
                            }
                            label={
                              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                <Typography variant="body2">
                                  Este item usa gestión de lotes
                                </Typography>
                                <Tooltip title="Activa el control de lotes con fechas de fabricación y vencimiento para este producto (sistema FIFO)">
                                  <InventoryIcon fontSize="small" sx={{ color: 'rgb(244, 147, 14)' }} />
                                </Tooltip>
                              </Box>
                            }
                          />
                        </Box>
                      )}
                    </CardContent>
                  </Card>

                  <Card elevation={1} sx={{ mb: 2, borderRadius: 2, overflow: "hidden", border: "1px solid", borderColor: "divider" }}>
                    <Box sx={{ px: 1.5, py: 1, borderBottom: "1px solid", borderColor: "divider", bgcolor: "grey.50", display: "flex", alignItems: "center", gap: 1 }}>
                      <ReceiptIcon sx={{ fontSize: 18, color: "text.secondary" }} />
                      <Typography variant="subtitle2" fontWeight={700} sx={{ fontSize: "0.9rem" }}>Impuesto del Ítem</Typography>
                    </Box>
                    <CardContent sx={{ p: 1.5 }}>
                      <Grid container spacing={1.5}>
                        <Grid item xs={12} md={6}>
                          <Autocomplete
                            size="small"
                            options={impuestosDisponibles}
                            getOptionLabel={(option) => `${option.descripcion} (${option.porcentaje}%)`}
                            value={impuestoSeleccionado}
                            onChange={handleImpuestoChange}
                            renderInput={(params) => <TextField {...params} label="Seleccionar Impuesto" variant="outlined" size="small" fullWidth />}
                            isOptionEqualToValue={(option, value) => option.id === value.id}
                          />
                        </Grid>
                        <Grid item xs={12} md={6}>
                          <FormControl fullWidth variant="outlined" size="small">
                            <InputLabel>Impuesto AFIP</InputLabel>
                            <Select
                              value={porcentajeImpuesto}
                              onChange={(e) => setPorcentajeImpuesto(Number(e.target.value))}
                              label="Impuesto AFIP"
                            >
                              {getIvaAFIP().map((impuesto) => (
                                <MenuItem key={impuesto.id} value={impuesto.porcentaje}>{impuesto.porcentaje}%</MenuItem>
                              ))}
                            </Select>
                          </FormControl>
                        </Grid>
                        <Grid item xs={12}>
                          <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 1.5 }}>
                            <Button
                              variant="contained"
                              size="small"
                              onClick={handleSaveImpuesto}
                              disabled={!impuestoSeleccionado || !selectedItem}
                              startIcon={<SaveIcon sx={{ fontSize: 18 }} />}
                              sx={{ borderRadius: 1, px: 2, py: 0.75, backgroundColor: "#5b5b5f", fontSize: "0.8rem" }}
                            >
                              Guardar Impuesto
                            </Button>
                          </Box>
                        </Grid>
                      </Grid>
                    </CardContent>
                  </Card>

                  <Card elevation={1} sx={{ borderRadius: 2, overflow: "hidden", border: "1px solid", borderColor: "divider" }}>
                    <Box sx={{ px: 1.5, py: 1, borderBottom: "1px solid", borderColor: "divider", bgcolor: "grey.50", display: "flex", alignItems: "center", gap: 1 }}>
                      <WarehouseIcon sx={{ fontSize: 18, color: "text.secondary" }} />
                      <Typography variant="subtitle2" fontWeight={700} sx={{ fontSize: "0.9rem" }}>Ubicaciones y Stock</Typography>
                    </Box>
                    <CardContent sx={{ p: 1.5 }}>
                      <Box sx={{ mb: 1.5 }}>
                        <FormControlLabel
                          control={<Checkbox size="small" checked={allSelected} indeterminate={someSelected} onChange={handleSelectAllChange} />}
                          label={<Typography variant="body2" sx={{ fontWeight: 500 }}>Seleccionar todas las ubicaciones</Typography>}
                        />
                      </Box>

                      <Grid container spacing={1.5}>
                        {ubicaciones.map((ub) => (
                          <Grid item xs={12} md={6} key={ub.id}>
                            <Card
                              variant="outlined"
                              sx={{
                                mb: 1.5,
                                borderColor: selectedUbicaciones.includes(ub.id) ? "primary.main" : "divider",
                                transition: "all 0.2s ease",
                                "&:hover": { boxShadow: 1 },
                              }}
                            >
                              <CardContent sx={{ p: 1.5 }}>
                                <FormControlLabel
                                  sx={{ width: "100%" }}
                                  control={
                                    <Checkbox
                                      size="small"
                                      value={ub.id}
                                      checked={selectedUbicaciones.includes(ub.id)}
                                      onChange={() => handleUbicacionChange(ub.id)}
                                      color="primary"
                                    />
                                  }
                                  label={<Typography variant="body2" sx={{ fontWeight: 500 }}>{ub.descripcion}</Typography>}
                                />

                                {selectedUbicaciones.includes(ub.id) && (
                                  <Box sx={{ display: "flex", gap: 1.5, mt: 1.5 }}>
                                    <TextField
                                      label="Inventario"
                                      value={
                                        ubicacionData[ub.id]?.inventario || ""
                                      }
                                      type="number"
                                      size="small"
                                      fullWidth
                                      onChange={(e) =>
                                        handleInventarioPrecioChange(
                                          ub.id,
                                          "inventario",
                                          e.target.value
                                        )
                                      }
                                      onBlur={(e) => {
                                        const value = e.target.value;
                                        if (value !== "" && !isNaN(parseFloat(value))) {
                                          handleInventarioPrecioChange(
                                            ub.id,
                                            "inventario",
                                            parseFloat(value).toFixed(3)
                                          );
                                        }
                                      }}
                                    />
                                    <TextField
                                      label="Stock Mínimo"
                                      value={
                                        ubicacionData[ub.id]?.stockMin || ""
                                      }
                                      type="number"
                                      size="small"
                                      fullWidth
                                      onChange={(e) =>
                                        handleInventarioPrecioChange(
                                          ub.id,
                                          "stockMin",
                                          e.target.value
                                        )
                                      }
                                    />
                                  </Box>
                                )}
                              </CardContent>
                            </Card>
                          </Grid>
                        ))}
                      </Grid>

                      <Box sx={{ display: "flex", justifyContent: "flex-end", mt: 2 }}>
                        <Button
                          variant="contained"
                          color="primary"
                          type="submit"
                          size="small"
                          disabled={savingItemInfo}
                          startIcon={
                            savingItemInfo ? (
                              <CircularProgress size={18} sx={{ color: "rgb(244, 147, 14)" }} />
                            ) : (
                              <SaveIcon sx={{ color: "rgb(244, 147, 14)", fontSize: 18 }} />
                            )
                          }
                          sx={{ borderRadius: 1, px: 2, py: 0.75, backgroundColor: "#5b5b5f", fontSize: "0.85rem" }}
                        >
                          {savingItemInfo ? "Guardando..." : "Guardar Información del Item"}
                        </Button>
                      </Box>
                    </CardContent>
                  </Card>
                </form>
              </TabPanel>

              <TabPanel value={activeTab} index={1}>
                {/* ── COSTOS DE PROVEEDORES ── */}
                <Card elevation={1} sx={{ mb: 2, borderRadius: 2, overflow: "hidden", border: "1px solid", borderColor: "divider" }}>
                  {/* Cabecera compacta */}
                  <Box sx={{ px: 1.5, py: 1, borderBottom: "1px solid", borderColor: "divider", bgcolor: "grey.50", display: "flex", alignItems: "center", gap: 1 }}>
                    <LocalShippingIcon sx={{ fontSize: 18, color: "text.secondary" }} />
                    <Typography variant="subtitle2" fontWeight={700} sx={{ fontSize: "0.9rem" }}>Costos de Proveedores</Typography>
                  </Box>

                  <Box sx={{ p: 1.5 }}>
                    {/* Formulario inline para agregar nuevo proveedor */}
                    <Box sx={{ display: "flex", gap: 1.5, alignItems: "flex-end", flexWrap: "wrap", p: 1, mb: 1.5, bgcolor: "grey.50", borderRadius: 1, border: "1px solid", borderColor: "grey.200" }}>
                      <Box sx={{ flex: "1 1 140px" }}>
                        <Typography variant="caption" color="text.secondary" fontWeight={600} display="block" mb={0.5}>Proveedor</Typography>
                        <Autocomplete
                          size="small"
                          options={availableProviderEntities}
                          getOptionLabel={(option) => `${option.descripcion} ${option.apellido}` || ""}
                          value={newProviderEntry.entidad ? entidadesProveedores.find((ent) => ent.id === newProviderEntry.entidad) || null : null}
                          onChange={(event, newValue) => handleNewProviderChange("entidad", newValue ? newValue.id : null)}
                          renderInput={(params) => <TextField {...params} placeholder="Seleccionar proveedor" variant="outlined" />}
                        />
                      </Box>
                      <Box sx={{ flex: "1 1 120px" }}>
                        <Typography variant="caption" color="text.secondary" fontWeight={600} display="block" mb={0.5}>Ubicación</Typography>
                        <Autocomplete
                          size="small"
                          options={availableUbicaciones}
                          getOptionLabel={(option) => option.descripcion || ""}
                          value={newProviderEntry.idUbicacion ? availableUbicaciones.find((ub) => ub.id === newProviderEntry.idUbicacion) || null : null}
                          onChange={(event, newValue) => handleNewProviderChange("idUbicacion", newValue ? newValue.id : null)}
                          renderInput={(params) => <TextField {...params} placeholder="Ubicación" variant="outlined" />}
                        />
                      </Box>
                      <Box sx={{ width: 110 }}>
                        <Typography variant="caption" color="text.secondary" fontWeight={600} display="block" mb={0.5}>Costo</Typography>
                        <TextField
                          size="small"
                          placeholder="0,00"
                          value={formatInputWithSeparators(newProviderEntry.monto, localeConfig.locale)}
                          onChange={(e) => handleNumericInputChange(e, (val) => handleNewProviderChange("monto", val), localeConfig.locale)}
                          fullWidth
                          InputProps={{
                            startAdornment: (
                              <InputAdornment position="start" sx={{ pointerEvents: "none", userSelect: "none" }}>
                                <Typography variant="body2" color="text.secondary">$</Typography>
                              </InputAdornment>
                            ),
                          }}
                        />
                      </Box>
                      <Box sx={{ width: 90 }}>
                        <Typography variant="caption" color="text.secondary" fontWeight={600} display="block" mb={0.5}>Margen (%)</Typography>
                        <TextField
                          size="small"
                          placeholder="0"
                          value={formatInputWithSeparators(newProviderEntry.margenGanancia, localeConfig.locale)}
                          onChange={(e) => handleNumericInputChange(e, (val) => handleNewProviderChange("margenGanancia", val), localeConfig.locale)}
                          fullWidth
                        />
                      </Box>
                      <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center", flexShrink: 0 }}>
                        <Typography variant="caption" color="text.secondary" fontWeight={600} display="block" mb={0}>Ref.</Typography>
                        <Checkbox
                          size="small"
                          checked={newProviderEntry.esProveedorReferente}
                          onChange={(e) => handleNewProviderChange("esProveedorReferente", e.target.checked)}
                          icon={<StarBorderIcon sx={{ fontSize: 20, color: "text.disabled" }} />}
                          checkedIcon={<StarIcon sx={{ fontSize: 20, color: "rgb(244,147,14)" }} />}
                          sx={{ p: 0.5 }}
                        />
                      </Box>
                      <Button
                        variant="contained"
                        onClick={handleAddNewProvider}
                        startIcon={<AddCircleOutlineIcon sx={{ fontSize: 18 }} />}
                        sx={{ height: 40, bgcolor: "rgb(244,147,14)", "&:hover": { bgcolor: "rgb(210,120,0)" }, borderRadius: 1, whiteSpace: "nowrap", flexShrink: 0, fontWeight: 600 }}
                      >
                        + Agregar
                      </Button>
                    </Box>

                    {/* Tabla unificada: existentes + pendientes - Estética TablaVentasComponent */}
                    <TableContainer component={Paper} variant="outlined" sx={{ borderRadius: "8px 8px 0 0", overflow: "hidden" }}>
                      <Table size="small">
                        <TableHead>
                          <TableRow sx={{ backgroundColor: "#5b5b5f", "& th": { color: "white !important", borderBottom: "2px solid #333", height: 36, fontSize: "0.875rem", fontWeight: 600 } }}>
                            <TableCell sx={{ width: 32, p: 1, color: "white !important" }} />
                            <TableCell sx={{ color: "white !important", textAlign: "left", pl: 2 }}>Proveedor</TableCell>
                            <TableCell sx={{ color: "white !important", textAlign: "left", pl: 2 }}>Ubicación</TableCell>
                            <TableCell sx={{ color: "white !important", textAlign: "center" }}>Costo</TableCell>
                            <TableCell sx={{ color: "white !important", textAlign: "center" }}>Margen %</TableCell>
                            <TableCell sx={{ color: "white !important", textAlign: "center" }}>Acciones</TableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {(editableListaPrecios || [])
                            .filter((row) => row.idEntidad && row.idTipoEntidad === 2)
                            .map((row, idx) => (
                              <TableRow
                                key={`${row.id}`}
                                hover
                                sx={{
                                  ...(row.esProveedorReferente ? { bgcolor: "rgba(249,115,22,0.06)" } : {}),
                                  "&:nth-of-type(even)": row.esProveedorReferente ? {} : { backgroundColor: "#F7F7F7" },
                                  "&:hover": { backgroundColor: alpha(theme.palette.primary.main, 0.08), transition: "background 0.3s ease" },
                                  "& td": { borderBottom: "1px solid #ccc", fontSize: "0.875rem", py: 0.5 },
                                }}
                              >
                                <TableCell sx={{ p: 1, textAlign: "center" }}>
                                  <Tooltip title={row.esProveedorReferente ? "Proveedor referente" : "No referente"}>
                                    {row.esProveedorReferente ? (
                                      <StarIcon sx={{ color: "rgb(244,147,14)", fontSize: 18 }} />
                                    ) : (
                                      <StarBorderIcon sx={{ color: "text.disabled", fontSize: 18 }} />
                                    )}
                                  </Tooltip>
                                </TableCell>
                                <TableCell sx={{ fontSize: "0.85rem", fontWeight: row.esProveedorReferente ? 600 : 400, textAlign: "left", pl: 2 }}>
                                  {row.descripcionEntidad || ""}
                                </TableCell>
                                <TableCell sx={{ fontSize: "0.78rem", color: "text.secondary", textAlign: "left", pl: 2 }}>{row.ubicacion || ""}</TableCell>
                                <TableCell sx={{ textAlign: "center" }}>
                                  <Box sx={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
                                    <TextField
                                      value={formatInputWithSeparators(row.monto, localeConfig.locale)}
                                      onChange={(e) => handleNumericInputChange(e, (val) => updateEditableRow(row.id, 2, val), localeConfig.locale)}
                                      size="small"
                                      variant="outlined"
                                      InputProps={{
                                        startAdornment: (
                                          <InputAdornment position="start" sx={{ pointerEvents: "none", userSelect: "none" }}>
                                            <Typography variant="body2" color="text.secondary">$</Typography>
                                          </InputAdornment>
                                        ),
                                      }}
                                      sx={{
                                        width: 110,
                                        "& .MuiOutlinedInput-root": {
                                          "& fieldset": { borderColor: "transparent" },
                                          "&:hover fieldset": { borderColor: "grey.400" },
                                          "&.Mui-focused fieldset": { borderColor: "rgb(244,147,14)" },
                                        },
                                        "& input": { textAlign: "right", fontWeight: 500, fontSize: "0.85rem", py: 0.5 },
                                      }}
                                    />
                                  </Box>
                                </TableCell>
                                <TableCell sx={{ textAlign: "center", fontSize: "0.85rem" }}>
                                  {row.margenGanancia != null ? `${formatNumberForDisplay(row.margenGanancia, { locale: localeConfig.locale })}%` : "—"}
                                </TableCell>
                                <TableCell sx={{ textAlign: "center" }}>
                                  <Tooltip title="Editar costo y margen">
                                    <IconButton size="small" onClick={() => handleOpenModalProveedor(row)}>
                                      <EditIcon sx={{ fontSize: 18 }} />
                                    </IconButton>
                                  </Tooltip>
                                </TableCell>
                              </TableRow>
                            ))}
                          {newProviderEntries.map((entry, idx) => (
                            <TableRow key={`prov_new_${idx}`} sx={{ bgcolor: "rgba(244,147,14,0.04)", "& td": { borderBottom: "1px solid #ccc", fontSize: "0.875rem", py: 0.5 } }}>
                              <TableCell sx={{ p: 1, textAlign: "center" }}>
                                {entry.esProveedorReferente ? (
                                  <StarIcon sx={{ color: "rgb(244,147,14)", fontSize: 18 }} />
                                ) : (
                                  <StarBorderIcon sx={{ color: "text.disabled", fontSize: 18 }} />
                                )}
                              </TableCell>
                              <TableCell sx={{ fontSize: "0.85rem", textAlign: "left", pl: 2 }}>
                                <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                                  {entidadesProveedores.find((ent) => ent.id === entry.entidad)?.descripcion || ""}
                                  <Chip label="Nuevo" size="small" sx={{ fontSize: "0.65rem", height: 18, bgcolor: "rgb(244,147,14)", color: "white" }} />
                                </Box>
                              </TableCell>
                              <TableCell sx={{ fontSize: "0.78rem", color: "text.secondary", textAlign: "left", pl: 2 }}>
                                {availableUbicaciones.find((ub) => ub.id === entry.idUbicacion)?.descripcion || ""}
                              </TableCell>
                              <TableCell sx={{ textAlign: "center", fontWeight: 500, fontSize: "0.85rem" }}>$ {formatNumberForDisplay(entry.monto, { locale: localeConfig.locale })}</TableCell>
                              <TableCell sx={{ textAlign: "center", fontSize: "0.85rem" }}>
                                {entry.margenGanancia !== "" && entry.margenGanancia !== null ? `${formatNumberForDisplay(entry.margenGanancia, { locale: localeConfig.locale })}%` : "—"}
                              </TableCell>
                              <TableCell sx={{ textAlign: "center" }}>
                                <IconButton color="error" size="small" onClick={() => handleDeleteNewEntry(idx, 2)}>
                                  <DeleteIcon sx={{ fontSize: 18 }} />
                                </IconButton>
                              </TableCell>
                            </TableRow>
                          ))}
                        </TableBody>
                      </Table>
                    </TableContainer>

                    <Box sx={{ display: "flex", justifyContent: "flex-end", gap: 1, mt: 1.5, flexWrap: "wrap" }}>
                      <Button
                        variant="outlined"
                        onClick={() => handleUpdateExisting(2)}
                        disabled={savingProveedores}
                        startIcon={savingProveedores ? <CircularProgress size={16} /> : <SaveIcon sx={{ fontSize: 18 }} />}
                        sx={{ borderRadius: 1, fontSize: "0.82rem", borderColor: "grey.400" }}
                      >
                        {savingProveedores ? "Guardando..." : "Actualizar"}
                      </Button>
                      {newProviderEntries.length > 0 && (
                        <Button
                          variant="contained"
                          onClick={() => handleSaveNewEntries(2)}
                          disabled={savingProveedores}
                          startIcon={savingProveedores ? <CircularProgress size={16} sx={{ color: "white" }} /> : <SaveIcon sx={{ fontSize: 18 }} />}
                          sx={{ bgcolor: "#5b5b5f", "&:hover": { bgcolor: "#4a4a4e" }, borderRadius: 1, fontSize: "0.82rem" }}
                        >
                          {savingProveedores ? "Guardando..." : "Guardar Nuevos Costos"}
                        </Button>
                      )}
                    </Box>
                  </Box>
                </Card>

                {/* ── PRECIOS DE CLIENTES ── */}
                <Card elevation={1} sx={{ mb: 2, borderRadius: 2, overflow: "hidden", border: "1px solid", borderColor: "divider" }}>
                  {/* Cabecera compacta */}
                  <Box sx={{ px: 1.5, py: 1, borderBottom: "1px solid", borderColor: "divider", bgcolor: "grey.50", display: "flex", alignItems: "center", gap: 1 }}>
                    <PeopleIcon sx={{ fontSize: 18, color: "text.secondary" }} />
                    <Typography variant="subtitle2" fontWeight={700} sx={{ fontSize: "0.9rem" }}>Precios de Clientes</Typography>
                  </Box>

                  <Box sx={{ p: 1.5 }}>
                    {/* Formulario inline para agregar nuevo */}
                    <Box sx={{ display: "flex", gap: 1.5, alignItems: "flex-end", flexWrap: "wrap", p: 1, mb: 1.5, bgcolor: "grey.50", borderRadius: 1, border: "1px solid", borderColor: "grey.200" }}>
                      <Box sx={{ flex: "1 1 160px" }}>
                        <Typography variant="caption" color="text.secondary" fontWeight={600} display="block" mb={0.5}>Cliente</Typography>
                        <Autocomplete
                          size="small"
                          options={availableClientEntities}
                          getOptionLabel={(option) => `${option.descripcion} ${option.apellido}` || ""}
                          value={newClientEntry.entidad ? entidadesClientes.find((ent) => ent.id === newClientEntry.entidad) || null : null}
                          onChange={(event, newValue) => handleNewClientChange("entidad", newValue ? newValue.id : null)}
                          renderInput={(params) => <TextField {...params} placeholder="Seleccionar cliente" variant="outlined" />}
                        />
                      </Box>
                      <Box sx={{ flex: "1 1 140px" }}>
                        <Typography variant="caption" color="text.secondary" fontWeight={600} display="block" mb={0.5}>Ubicación</Typography>
                        <Autocomplete
                          size="small"
                          options={availableUbicaciones}
                          getOptionLabel={(option) => option.descripcion || ""}
                          value={newClientEntry.idUbicacion ? availableUbicaciones.find((ub) => ub.id === newClientEntry.idUbicacion) || null : null}
                          onChange={(event, newValue) => handleNewClientChange("idUbicacion", newValue ? newValue.id : null)}
                          renderInput={(params) => <TextField {...params} placeholder="Ubicación" variant="outlined" />}
                        />
                      </Box>
                      <Box sx={{ width: 130 }}>
                        <Typography variant="caption" color="text.secondary" fontWeight={600} display="block" mb={0.5}>Precio</Typography>
                        <TextField
                          size="small"
                          placeholder="0,00"
                          value={formatInputWithSeparators(newClientEntry.monto, localeConfig.locale)}
                          onChange={(e) => handleNumericInputChange(e, (val) => handleNewClientChange("monto", val), localeConfig.locale)}
                          fullWidth
                          InputProps={{
                            startAdornment: (
                              <InputAdornment position="start" sx={{ pointerEvents: "none", userSelect: "none" }}>
                                <Typography variant="body2" color="text.secondary">$</Typography>
                              </InputAdornment>
                            ),
                          }}
                        />
                      </Box>
                      <Button
                        variant="contained"
                        onClick={handleAddNewClient}
                        startIcon={<AddCircleOutlineIcon sx={{ fontSize: 18 }} />}
                        sx={{ height: 40, bgcolor: "rgb(244,147,14)", "&:hover": { bgcolor: "rgb(210,120,0)" }, borderRadius: 1, whiteSpace: "nowrap", flexShrink: 0, fontWeight: 600 }}
                      >
                        + Agregar
                      </Button>
                    </Box>

                    {/* Tabla unificada: existentes + pendientes - Estética TablaVentasComponent */}
                    <TableContainer component={Paper} variant="outlined" sx={{ borderRadius: "8px 8px 0 0", overflow: "hidden" }}>
                      <Table size="small">
                        <TableHead>
                          <TableRow sx={{ backgroundColor: "#5b5b5f", "& th": { color: "white !important", borderBottom: "2px solid #333", height: 36, fontSize: "0.875rem", fontWeight: 600 } }}>
                            <TableCell sx={{ color: "white !important", textAlign: "left", pl: 2 }}>Cliente</TableCell>
                            <TableCell sx={{ color: "white !important", textAlign: "left", pl: 2 }}>Ubicación</TableCell>
                            <TableCell sx={{ color: "white !important", textAlign: "center" }}>Precio</TableCell>
                            <TableCell sx={{ color: "white !important", textAlign: "center" }}>Acciones</TableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {(editableListaPrecios || [])
                            .filter((row) => row.idEntidad && row.idTipoEntidad === 1)
                            .map((row, idx) => (
                              <TableRow
                                key={`${row.id}`}
                                hover
                                sx={{
                                  "&:nth-of-type(even)": { backgroundColor: "#F7F7F7" },
                                  "&:hover": { backgroundColor: alpha(theme.palette.primary.main, 0.08), transition: "background 0.3s ease" },
                                  "& td": { borderBottom: "1px solid #ccc", fontSize: "0.875rem", py: 0.5 },
                                }}
                              >
                                <TableCell sx={{ fontSize: "0.85rem", textAlign: "left", pl: 2 }}>{row.descripcionEntidad || ""}</TableCell>
                                <TableCell sx={{ fontSize: "0.78rem", color: "text.secondary", textAlign: "left", pl: 2 }}>{row.ubicacion || ""}</TableCell>
                                <TableCell sx={{ textAlign: "center" }}>
                                  <Box sx={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
                                    <TextField
                                      value={formatInputWithSeparators(row.monto, localeConfig.locale)}
                                      onChange={(e) => handleNumericInputChange(e, (val) => updateEditableRow(row.id, 1, val), localeConfig.locale)}
                                      size="small"
                                      variant="outlined"
                                      InputProps={{
                                        startAdornment: (
                                          <InputAdornment position="start" sx={{ pointerEvents: "none", userSelect: "none" }}>
                                            <Typography variant="body2" color="text.secondary">$</Typography>
                                          </InputAdornment>
                                        ),
                                      }}
                                      sx={{
                                        width: 110,
                                        "& .MuiOutlinedInput-root": {
                                          "& fieldset": { borderColor: "transparent" },
                                          "&:hover fieldset": { borderColor: "grey.400" },
                                          "&.Mui-focused fieldset": { borderColor: "rgb(244,147,14)" },
                                        },
                                        "& input": { textAlign: "right", fontWeight: 500, fontSize: "0.85rem", py: 0.5 },
                                      }}
                                    />
                                  </Box>
                                </TableCell>
                                <TableCell sx={{ textAlign: "center" }}>
                                  <Tooltip title="Editar precio (tipo ajuste)">
                                    <IconButton size="small" onClick={() => handleOpenModalPrecioCliente(row)}>
                                      <EditIcon sx={{ fontSize: 18 }} />
                                    </IconButton>
                                  </Tooltip>
                                </TableCell>
                              </TableRow>
                            ))}
                          {newClientEntries.map((entry, idx) => (
                            <TableRow key={`client_new_${idx}`} sx={{ bgcolor: "rgba(244,147,14,0.04)", "& td": { borderBottom: "1px solid #ccc", fontSize: "0.875rem", py: 0.5 } }}>
                              <TableCell sx={{ fontSize: "0.85rem", textAlign: "left", pl: 2 }}>
                                <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                                  {entidadesClientes.find((ent) => ent.id === entry.entidad)?.descripcion || ""}
                                  <Chip label="Nuevo" size="small" sx={{ fontSize: "0.65rem", height: 18, bgcolor: "rgb(244,147,14)", color: "white" }} />
                                </Box>
                              </TableCell>
                              <TableCell sx={{ fontSize: "0.78rem", color: "text.secondary", textAlign: "left", pl: 2 }}>
                                {availableUbicaciones.find((ub) => ub.id === entry.idUbicacion)?.descripcion || ""}
                              </TableCell>
                              <TableCell sx={{ textAlign: "center", fontWeight: 500, fontSize: "0.85rem" }}>$ {formatNumberForDisplay(entry.monto ?? 0, { locale: localeConfig.locale })}</TableCell>
                              <TableCell sx={{ textAlign: "center" }}>
                                <IconButton color="error" size="small" onClick={() => handleDeleteNewEntry(idx, 1)}>
                                  <DeleteIcon sx={{ fontSize: 18 }} />
                                </IconButton>
                              </TableCell>
                            </TableRow>
                          ))}
                        </TableBody>
                      </Table>
                    </TableContainer>

                    <Box sx={{ display: "flex", justifyContent: "flex-end", gap: 1, mt: 1.5, flexWrap: "wrap" }}>
                      <Button
                        variant="outlined"
                        onClick={() => handleUpdateExisting(1)}
                        disabled={savingClientes}
                        startIcon={savingClientes ? <CircularProgress size={16} /> : <SaveIcon sx={{ fontSize: 18 }} />}
                        sx={{ borderRadius: 1, fontSize: "0.82rem", borderColor: "grey.400" }}
                      >
                        {savingClientes ? "Guardando..." : "Actualizar"}
                      </Button>
                      {newClientEntries.length > 0 && (
                        <Button
                          variant="contained"
                          onClick={() => handleSaveNewEntries(1)}
                          disabled={savingClientes}
                          startIcon={savingClientes ? <CircularProgress size={16} sx={{ color: "white" }} /> : <SaveIcon sx={{ fontSize: 18 }} />}
                          sx={{ bgcolor: "#5b5b5f", "&:hover": { bgcolor: "#4a4a4e" }, borderRadius: 1, fontSize: "0.82rem" }}
                        >
                          {savingClientes ? "Guardando..." : "Guardar Nuevos Precios"}
                        </Button>
                      )}
                    </Box>

                  </Box>
                </Card>
              </TabPanel>


              {/* Tab Panel 2: Gestión de Lotes */}
              {parametrosGlobales?.gestionDeLotes === "1" && usaGestionLotes && (
                <TabPanel value={activeTab} index={2}>
                  <GestionLoteTab
                    ref={gestionLoteTabRef}
                    itemId={selectedItem.idItem}
                    ubicaciones={ubicaciones}
                  />
                </TabPanel>
              )}
            </Box>
          </>
        )}
      </Box>

      {/* Checkbox para marcar como eliminado - banner compacto */}
      <Box
        sx={{
          px: 2,
          py: 0.75,
          backgroundColor: "#FEF3C7",
          borderTop: "1px solid #FDE68A",
        }}
      >
        <FormControlLabel
          control={
            <Checkbox
              checked={itemEliminado}
              onChange={(e) => setItemEliminado(e.target.checked)}
              color="warning"
              sx={{
                color: theme.palette.warning.main,
                '&.Mui-checked': {
                  color: theme.palette.warning.main,
                },
              }}
            />
          }
          label={
            <Typography
              variant="body1"
              sx={{
                fontWeight: 500,
                color: itemEliminado ? theme.palette.warning.main : theme.palette.text.primary,
              }}
            >
              Marcar como eliminado
            </Typography>
          }
        />
        {itemEliminado && (
          <Typography
            variant="body2"
            sx={{
              ml: 4,
              color: theme.palette.warning.main,
              fontStyle: 'italic',
            }}
          >
            ⚠️ Este ítem no aparecerá en las búsquedas del inventario
          </Typography>
        )}
      </Box>

      {/* Footer con botón de guardar todo */}
      <AppBar
        position="sticky"
        color="default"
        elevation={3}
        sx={{
          top: "auto",
          bottom: 0,
          borderBottomLeftRadius: "8px",
          borderBottomRightRadius: "8px",
          backgroundColor: "#4B5563",
          borderTop: "1px solid #6B7280",
        }}
      >
        <Toolbar sx={{ justifyContent: "space-between" }}>
          <Button
            onClick={onClose}
            variant="outlined"
            sx={{
              borderRadius: 1,
              mr: 1,
              textTransform: "none",
              fontWeight: 500,
              borderColor: "grey.400",
              color: "white",
              "&:hover": { borderColor: "white", bgcolor: "rgba(255,255,255,0.08)" },
            }}
          >
            Cancelar
          </Button>

          <Button
            onClick={handleSaveAll}
            variant="contained"
            disabled={isSaving}
            startIcon={
              isSaving ? (
                <CircularProgress size={18} sx={{ color: "rgb(244,147,14)" }} />
              ) : (
                <SaveIcon sx={{ color: "rgb(244,147,14)" }} />
              )
            }
            sx={{
              borderRadius: 1,
              textTransform: "none",
              fontWeight: 600,
              px: 3,
              py: 1,
              bgcolor: "#374151",
              color: "white",
              border: "1px solid #6B7280",
              "&:hover": { bgcolor: "#1F2937" },
            }}
          >
            {isSaving ? "Guardando..." : "Guardar Todos los Cambios"}
          </Button>
        </Toolbar>
      </AppBar>

      {/* Modal de edición de costo y margen de proveedor */}
      <ModalEditarPrecioId
        open={openModalProveedor}
        handleClose={handleCloseModalProveedor}
        precioLista={precioListaSeleccionado}
        localeConfig={localeConfig}
        onUpdate={async (idItem, idEntidad, idUbicacion, nuevoMonto, tipoAjuste) => {
          await updateItemPrecioListaId(idItem, idEntidad, idUbicacion, nuevoMonto, tipoAjuste);
          await refreshListaMontos();
        }}
        onUpdateMargen={async (idItem, idEntidad, idUbicacion, margen) => {
          await updateMargenGananciaFiltrado(
            margen,
            "valor",
            { idItem, idEntidad, idUbicacion, idTipoEntidad: 2, soloUltimos: true }
          );
          await refreshListaMontos();
        }}
        onPromoverReferente={async (idItem, idEntidad, idUbicacion, monto, tipoAjuste, margenGanancia, idEntidadesCliente) => {
          await promoverProveedorReferente(idItem, idEntidad, idUbicacion, monto, tipoAjuste, margenGanancia, idEntidadesCliente);
          await refreshListaMontos();
        }}
        onActualizarPreciosClientes={async (idItem, idEntidad, idUbicacion, idEntidadesCliente) => {
          await actualizarPreciosClientesDesdeReferente(idItem, idEntidad, idUbicacion, idEntidadesCliente);
          await refreshListaMontos();
        }}
        getClientesConPreciosByFiltros={getClientesConPreciosByFiltros}
      />

      {/* Modal de edición de precio de cliente */}
      <ModalEditarPrecioCliente
        open={openModalPrecioCliente}
        handleClose={handleCloseModalPrecioCliente}
        precioCliente={precioClienteSeleccionado}
        localeConfig={localeConfig}
        onGuardar={async (idItem, idEntidad, idUbicacion, monto, tipoAjuste) => {
          await updateItemPrecioListaId(idItem, idEntidad, idUbicacion, monto, tipoAjuste);
          await refreshListaMontos();
          showNotification("Precio actualizado correctamente", "success");
        }}
      />

      {/* Notificaciones */}
      <Snackbar
        open={notification.open}
        autoHideDuration={5000}
        onClose={handleCloseNotification}
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
      >
        <Alert
          onClose={handleCloseNotification}
          severity={notification.severity}
          variant="filled"
          sx={{ width: "100%" }}
        >
          {notification.message}
        </Alert>
      </Snackbar>
    </Box>
  );
};

export default CreateItemComponentModal;
